<template>
  <a-link :to="ROUTE_NAME.PREMIUM" aria-label="Go to investingLive Premium">
    <div class="premium-banner__wrapper">
      <a-image
        :src="$helper.getLinkToIlBucketFile('premium-banner-il-v2.jpg')"
        :alt="$options.consts.altText"
        class="premium-banner__image-sm"
      />
      <div class="premium-banner__text">
        <div class="premium-banner__title">
          investingLive Premium
        </div>
        <div class="premium-banner__subtitle">
          Gain Access
        </div>
      </div>
    </div>
  </a-link>
</template>

<script>
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'PremiumBanner',
  consts: {
    altText: 'investingLive Premium'
  },
  data() {
    return {
      ROUTE_NAME
    }
  }
}
</script>

<style lang="scss" scoped>
.premium-banner__wrapper {
  margin-top: 20px;
  border-radius: 4px;
  display: flex;
  overflow: hidden;

  .premium-banner__image-sm {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }

  .premium-banner__text {
    background: $c--black;
    padding: 26px 16px;
    flex: 1;
  }

  .premium-banner__title {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: -0.15px;
    line-height: 16px;
    color: $c--gray-light;
    margin-bottom: 8px;
  }

  .premium-banner__subtitle {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.2px;
    color: $c--white;
  }
}
</style>
